export type ArrowId = number;
export const DEFAULT_ARROW_IMAGE_PATH = '/textures/arrow.png';
